import { render, staticRenderFns } from "./LinksMixin.vue?vue&type=template&id=42836606"
import script from "./LinksMixin.vue?vue&type=script&lang=ts"
export * from "./LinksMixin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports